import React, { useState, useEffect } from 'react';
import CourseCard from '../../Course/CourseCard/CourseCard';

export default function CoursesIndexCard({ get_courses_endpoint }) {
	const [
		courses,
		setCourses
	] = useState([]);
	const [
		difficulty,
		setDifficulty
	] = useState([]);
	const [
		topics,
		setTopics
	] = useState([]);

	useEffect(
		() => {
			fetchCourses();
		},
		[
			difficulty,
			topics
		]
	);

	const fetchCourses = () => {
		window.scrollTo(0, 0);

		let queryParams = '';

		if (difficulty.length) queryParams += `difficulty=${difficulty.join(',')}`;
		if (topics.length) queryParams += `&topics=${topics.join(',')}`;

		fetch(`${get_courses_endpoint}?${queryParams}`)
			.then((response) => response.json())
			.then((result) => {
				setCourses(result.data || []);
			})
			.catch((error) => {
				console.error('Error fetching courses:', error);
			});
	};

	const getDifficultyLevel = (level) => {
		const levels = { 0: 'Beginner', 1: 'Intermediate', 2: 'Advanced' };
		return levels[level] || 'Unknown';
	};

	return (
		<main className="text-gray-800 dark:text-dark-text">
			{/* Filter Section */}
			<div className="mb-6">
				<div className="flex flex-col space-y-4 md:space-y-0 md:flex-row md:items-center md:justify-start md:space-x-10">
					{/* Filter by Difficulty */}
					<div className="flex items-center flex-wrap gap-2 md:gap-4">
						<span className="hidden md:inline-block font-semibold text-gray-700 dark:text-dark-text whitespace-nowrap">
							Filter by Difficulty
						</span>
						<div className="flex flex-wrap gap-2">
							{[
								'Beginner',
								'Intermediate',
								'Advanced'
							].map((level) => (
								<button
									key={level}
									onClick={() =>
										setDifficulty(
											difficulty.includes(level)
												? difficulty.filter((d) => d !== level)
												: [
														...difficulty,
														level
													]
										)}
									className={`px-3 py-1 rounded-full border text-sm md:text-base ${difficulty.includes(
										level
									)
										? 'bg-blue-500 text-white'
										: 'border-gray-400 dark:border-dark-border text-gray-700 dark:text-dark-text bg-white dark:bg-dark-card'}`}
								>
									{level}
								</button>
							))}
						</div>
					</div>

					{/* Filter by Topic */}
					<div className="flex items-center flex-wrap gap-2 md:gap-4">
						<span className="hidden md:inline-block font-semibold text-gray-700 dark:text-dark-text whitespace-nowrap">
							Filter by Topic
						</span>
						<div className="flex flex-wrap gap-2">
							{[
								'Dynasty',
								'Best Ball',
								'DFS'
							].map((topic) => (
								<button
									key={topic}
									onClick={() =>
										setTopics(
											topics.includes(topic)
												? topics.filter((t) => t !== topic)
												: [
														...topics,
														topic
													]
										)}
									className={`px-3 py-1 rounded-full border text-sm md:text-base ${topics.includes(
										topic
									)
										? 'bg-blue-500 text-white'
										: 'border-gray-400 dark:border-dark-border text-gray-700 dark:text-dark-text bg-white dark:bg-dark-card'}`}
								>
									{topic}
								</button>
							))}
						</div>
					</div>
				</div>
			</div>

			{/* Course Tiles */}
			<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
				{courses.map((course) => (
					<CourseCard
						key={course.id}
						course={course}
						getDifficultyLevel={getDifficultyLevel}
					/>
				))}
			</div>
		</main>
	);
}
